import { useNonAccess } from "@templates/course/hooks/useNonAccess";
import { useState, Fragment } from "react";
import { Button } from "@shared/components";
import { IconChevronDown } from "@svg/chevron-down";
import { twMerge } from "tailwind-merge";
import useCourseContent from "./non-access/hook/useCoutrseContent";
import { BUTTON_SIZE, BUTTON_VARIANT } from "@shared/components/button";

interface Props {
  id?: string;
}

const CourseContent: React.FC<Props> = ({ id }) => {
  const { courseContentItem } = useNonAccess();
  const { expandableItems, staticItems } = useCourseContent();

  const [isExpanded, setIsExpanded] = useState(false);

  const checkPdf =
    courseContentItem
      .filter((d) => d.enable)
      .findIndex((d) => d.title === "فایل PDF یادداشت‌ها و اسلایدها") === 2;

  const isExpandable = Boolean(expandableItems?.length);
  return (
    <div id={id} className="py-6  md:py-8">
      <h2 className="headline-sm md:headline-md mb-3  md:mb-5">محتوای آموزش</h2>
      <div className="grid grid-rows-[1fr]">
        <div className="overflow-hidden min-h-0">
          <div
            className={twMerge(
              "grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-y-5 h-fit pb-1",
              !checkPdf && "gap-x-2"
            )}
          >
            {staticItems.map((item, index) => {
              return <Fragment key={index}>{item}</Fragment>;
            })}
          </div>
        </div>
      </div>
      {isExpandable && (
        <>
          <div
            className={twMerge(
              "grid transition-[grid-template-rows] duration-500 ease-in-out",
              isExpanded ? "grid-rows-[1fr] my-5" : "grid-rows-[0fr]"
            )}
          >
            <div className="overflow-hidden min-h-0">
              <div
                className={twMerge(
                  "grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-y-5 h-fit pb-1",
                  !checkPdf && "gap-x-2"
                )}
              >
                {expandableItems.map((item, index) => {
                  const isHidden = !isExpanded;
                  if (isHidden) return null;
                  return <Fragment key={index}>{item}</Fragment>;
                })}
              </div>
            </div>
          </div>
          {!isExpanded && (
            <div className="w-full flex justify-start mt-5">
              <Button
                endIcon={<IconChevronDown />}
                onClick={() => setIsExpanded(true)}
                className="self-start"
                variant={BUTTON_VARIANT.TEXT_ACTION}
                size={BUTTON_SIZE.LARGE}
              >
                بیشتر
              </Button>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default CourseContent;
